module.exports = __webpack_public_path__ + "static/media/Athelas-Bold.029e0ee4.woff";